import {
    GetActivePricingRotationsRequest,
    GetActivePricingRotationsRequest_PricingTypeFilter,
    GetActivePricingRotationsResponse_PricingRotation,
} from '@app/_proto/Protos/pricing';
import { PricingClient } from '@app/_proto/Protos/pricing.client';
import { useGrpcApiWithQuery } from '@app/libs/api';
import { useGrpcRequest } from '@app/libs/grpc';

type UseNovelPricingRotationsOptions = {
    type?: GetActivePricingRotationsRequest_PricingTypeFilter;
    enabled?: boolean;
};

type UseNovelPricingRotationsReturn = {
    isLoading: boolean;
    data: GetActivePricingRotationsResponse_PricingRotation[] | undefined;
};

export default function useNovelPricingRotations({
    enabled,
    type,
}: UseNovelPricingRotationsOptions = {}): UseNovelPricingRotationsReturn {
    const request = useGrpcRequest(GetActivePricingRotationsRequest, { type });

    const { data, isLoading } = useGrpcApiWithQuery(
        PricingClient,
        c => c.getActivePricingRotations,
        request,
        ['novel-pricings'],
        {
            enabled,
        }
    );

    return {
        isLoading: isLoading,
        data: data?.items || [],
    };
}
